import { injectable } from "tsyringe";
import { IStoreRepository } from "$src/domain/directory/stores/IStoreRepository";
import { Store } from "$src/domain/directory/stores/Store";
import { ApiRoutes } from "$src/infrastructure/apiConfig/ApiRoutes";
import { BaseApi } from "$src/infrastructure/apiConfig/BaseApi";

@injectable()
export class StoreRepositoryApi extends BaseApi implements IStoreRepository {
    
    async getStoreById(groupStoreId: number, storeId: number): Promise<Store> {
        try {

            const route = `${ApiRoutes.STORES.endpoint(groupStoreId.toString())}/stores`;

            const response = await this.apiClient.get<Store>(route, storeId);
            
            return response;
        } catch (error) {
            console.error('Error fetching store by id:', error);
            throw error; 
        }
    }
}